import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (id: string) => {
    setIsMobileMenuOpen(false);
    if (location.pathname === '/') {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(`/#${id}`);
    }
  };

  const handleHomeClick = () => {
    setIsMobileMenuOpen(false);
    navigate('/');
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-md`}>
      <div className="w-full px-6 lg:px-8">
        <div className="flex items-center justify-center h-20">
          <div className="absolute left-6 lg:left-8 flex items-center gap-3 cursor-pointer" onClick={handleHomeClick}>
            <img 
              src="https://public.readdy.ai/ai/img_res/12380adb-ff42-473d-83d9-042ff7dc24ba.png" 
              alt="Fish Box Studios Logo" 
              className="w-28 h-28"
              style={{ objectFit: 'contain', background: 'transparent' }}
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <a 
              onClick={() => handleNavClick('choke-point')} 
              className="font-medium transition-colors cursor-pointer text-gray-700 hover:text-orange-500"
            >
              Our Game
            </a>
            <a 
              onClick={() => handleNavClick('about')} 
              className="font-medium transition-colors cursor-pointer text-gray-700 hover:text-orange-500"
            >
              About
            </a>
            <a 
              onClick={() => handleNavClick('contact')} 
              className="font-medium transition-colors cursor-pointer text-gray-700 hover:text-orange-500"
            >
              Contact
            </a>
          </div>

          <button
            className="md:hidden absolute right-6"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className="ri-menu-line text-2xl text-gray-900"></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            <a onClick={() => handleNavClick('choke-point')} className="block py-2 hover:text-orange-500 transition-colors cursor-pointer">Our Game</a>
            <a onClick={() => handleNavClick('about')} className="block py-2 hover:text-orange-500 transition-colors cursor-pointer">About</a>
            <a onClick={() => handleNavClick('contact')} className="block py-2 hover:text-orange-500 transition-colors cursor-pointer">Contact</a>
          </div>
        </div>
      )}
    </nav>
  );
}